import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  getImageSrc(imageName: string): string {
    if (window.location.hostname === 'localhost') {
      return `/assets/images/${imageName}`;
    }
    return `https://vstatic-prod.apigateway.co/partner-center-client.9223372035099833042.prod/assets/images/${imageName}`;
  }
}
